if (!customElements.get('product-form-alt')) {
  customElements.define(
    'product-form-alt',
    class ProductFormAlt extends HTMLElement {
      constructor() {
        super();

        this.variantIdInput.disabled = false;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('.js-submit');
        this.submitButtonText = this.submitButton?.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.submitButton?.addEventListener('click', this.onSubmitClick.bind(this))
      }

      onSubmitClick(e) {
        e.preventDefault()

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.body = JSON.stringify({
          items: [
            {
              id: this.variantIdInput.value,
              quantity: 1,
              properties: Object.assign({}, !!this.dataset.parentId ? {
                _parent_id: this.dataset.parentId
              } : {})
            }
          ],
          sections: this.cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        })

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form-alt',
                productVariantId: this.variantIdInput.value,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form-alt',
                productVariantId: this.variantIdInput.value,
                cartData: response,
              });
            this.error = false;

            if (!!response.sections['cart-icon-bubble']) {
              document.querySelector('#cart-icon-bubble').innerHTML = response.sections['cart-icon-bubble']
            }

            if (!!response.sections['cart-drawer']) {
              document.querySelector('#shopify-section-cart-drawer').innerHTML = response.sections['cart-drawer']
              document.querySelector('#shopify-section-cart-drawer .drawer').classList.add('active')
            }
          }).catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });

      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.querySelector('[name=id]');
      }
    }
  );
}
